export const content = {
  errors: {
    required: 'Eingabe erforderlich',
    decimal2: "Der Wert darf maximal 2 Nachkommastellen haben",
    decimal1: "Der Wert darf maximal 1 Nachkommastelle haben",
    roofValidation:
      'Für Ihre angegebenen Abmessungen ist keine Berechnung möglich. Hierzu berät Sie gerne unsere Anwendungstechnik:',
  },
}
